import { Dialog, DialogContent, DialogDescription } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import AuthForm from "./AuthForm";

interface AuthModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialMode?: "login" | "signup" | "forgot-password" | "update-password";
}

const AuthModal = ({ open, onOpenChange, initialMode = "login" }: AuthModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[450px] p-6 sm:p-8 max-sm:fixed max-sm:bottom-0 max-sm:top-auto max-sm:left-0 max-sm:translate-x-0 max-sm:translate-y-0 max-sm:w-full max-sm:max-w-none max-sm:rounded-t-3xl max-sm:rounded-b-none max-sm:max-h-[92vh] max-sm:pb-[max(1.5rem,env(safe-area-inset-bottom))]">
        <div className="mx-auto -mt-2 mb-4 h-1.5 w-12 rounded-full bg-muted-foreground/30 sm:hidden" />
        {/* Visually hidden description for accessibility (Radix requirement) */}
        <VisuallyHidden>
          <DialogDescription>
            Formulario de autenticación para iniciar sesión o registrarse en Brickshare
          </DialogDescription>
        </VisuallyHidden>
        <AuthForm 
          initialMode={initialMode} 
          onSuccess={() => onOpenChange(false)} 
        />
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
